type Context = 'teammate';

type Section = 'threads' | 'thread-title';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  threads: 'teammate-threads',
  'thread-title': 'teammate-thread-title',
};
